<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Consulta censo</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span class="grey-text">Reportes</span>
      <span> /</span>
      <span>Consulta censo</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-body">
      <div class="col dato p-0" style="max-width: 300px">
        <Strong class="title">ID Reporte</Strong>
        <span class="value">100000234</span>
      </div>
      <div class="col dato p-0" style="max-width: 300px">
        <Strong class="title">Fecha</Strong>
        <span class="value">05/05/2020</span>
      </div>
      <div class="col dato p-0" style="max-width: 300px">
        <Strong class="title">Vendedor</Strong>
        <span class="value">Jorge Vargas</span>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Cliente</th>
            <th scope="col">N° Placa</th>
            <th scope="col">Marca</th>
            <th scope="col">Modelo</th>
            <th scope="col">Estado</th>
            <th scope="col">Estado actual</th>
            <th scope="col">Observaciones</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>VICTOR TORREJON</td>
            <td>MIMET</td>
            <td>513245</td>
            <td>CV-350</td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td style="width: 350px">Se encuentra en buen estado</td>
          </tr>
          <tr>
            <td>VICTOR TORREJON</td>
            <td>MIMET</td>
            <td>513245</td>
            <td>CV-350</td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td><mdb-badge pill="true" success="true">Buena</mdb-badge></td>
            <td style="width: 350px">Se encuentra en buen estado</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">
      Imprimir
    </button>
  </div>
</div>
